//Function to generate an adress from an addressVM
//Returns 
export const formatAddress = (addressVm, showName) => {
    var addressStr = ""
    if ( addressVm != null)
        {
            if (addressVm.Name && showName) addressStr += (addressVm.Name + ", ")
            if (addressVm.StreetNameAndNumber) addressStr += (addressVm.StreetNameAndNumber + ", ")
            if (addressVm.PostalCode) addressStr += (addressVm.PostalCode + " ")
            if (addressVm.City) addressStr += addressVm.City
            addressStr = addressStr.trim().replace(/(,$)/, '');
        }
    return addressStr;
}